import React from 'react';
import AdminNavbar from './AdminNavbar';
import UploadCSV from './UploadCSV';

import './AdminModern.css';

const AdminUpload = () => {
  return (
    <div className="admin-page-wrapper">
      <div className="admin-bg" />
      <AdminNavbar />
      <div className="admin-main-container">
        <div 
          className="admin-glass-card no-hover"
          style={{
            // Disable hover effects that cause cursor jumping
            transform: 'none !important',
            transition: 'none !important'
          }}
        >
          <UploadCSV adminMode={true} />
        </div>
      </div>
    </div>
  );
};

export default AdminUpload; 